(function() {
  'use strict';

  var STORAGE_KEY = 'nb-recently-viewed';
  var MAX_ITEMS = 6;
  var ACTIVATE_THRESHOLD = 3;

  function getHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (err) {
      return [];
    }
  }

  function saveHistory(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (err) {}
  }

  function trackCurrent(currentHandle) {
    if (!currentHandle) return;
    var history = getHistory();
    history = history.filter(function(h) { return h !== currentHandle; });
    history.unshift(currentHandle);
    history = history.slice(0, MAX_ITEMS + 1);
    saveHistory(history);
  }

  function fetchProductCard(handle) {
    return fetch('/products/' + handle + '?view=card', {
      headers: { 'Accept': 'text/html' }
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Not found: ' + handle);
        return res.text();
      });
  }

  function isSoldOutCardHtml(html) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var rootEl = doc.body.querySelector('[data-available]');
      if (!rootEl) return false;
      return rootEl.getAttribute('data-available') === 'false';
    } catch (err) {
      return false;
    }
  }

  function showRecentlyViewed(section, history) {
    var grid = section.querySelector('[data-nb-recently-viewed-grid]');
    if (!grid) return Promise.resolve(false);

    var handlesToShow = history.slice(0, MAX_ITEMS);

    var promises = handlesToShow.map(function(handle) {
      return fetchProductCard(handle)
        .then(function(html) { return { handle: handle, html: html }; })
        .catch(function() { return null; });
    });

    return Promise.all(promises).then(function(results) {
      var validResults = results.filter(function(r) { return r !== null; });

      /* Sold-Out Filter · Card-HTML auf data-available="false" prüfen.
         Sold-Outs werden aus dem Slider verbannt selbst wenn der User sie kürzlich angeschaut hat. */
      validResults = validResults.filter(function(r) { return !isSoldOutCardHtml(r.html); });

      if (validResults.length < ACTIVATE_THRESHOLD) {
        return false;
      }

      grid.innerHTML = validResults.map(function(r) { return r.html; }).join('');
      section.style.display = 'block';
      section.classList.add('is-revealed');
      setTimeout(bindSliderArrows, 50);
      return true;
    });
  }

  function bindSliderArrows() {
    var track = document.querySelector('[data-nb-rv-track]');
    var prevBtn = document.querySelector('[data-nb-rv-prev]');
    var nextBtn = document.querySelector('[data-nb-rv-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function getCardWidth() {
      var firstCard = track.children[0];
      if (!firstCard) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    if (!prevBtn.dataset.nbBound) {
      prevBtn.dataset.nbBound = 'true';
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
    }

    if (!nextBtn.dataset.nbBound) {
      nextBtn.dataset.nbBound = 'true';
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    }

    if (!track.dataset.nbBound) {
      track.dataset.nbBound = 'true';
      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
    }

    updateButtons();
  }

  function hideRelatedBlock() {
    var related = document.querySelector('[data-nb-related-block]');
    if (related) related.style.display = 'none';
  }

  function showRelatedBlock() {
    var related = document.querySelector('[data-nb-related-block]');
    if (related) related.style.display = '';
  }

  function init() {
    var section = document.querySelector('[data-nb-recently-viewed]');
    if (!section) return;

    var currentHandle = section.getAttribute('data-current-handle');
    trackCurrent(currentHandle);

    var history = getHistory().filter(function(h) { return h !== currentHandle; });

    if (history.length < ACTIVATE_THRESHOLD) {
      showRelatedBlock();
      section.style.display = 'none';
      return;
    }

    showRecentlyViewed(section, history).then(function(success) {
      if (success) {
        hideRelatedBlock();
      } else {
        showRelatedBlock();
        section.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
